import React from 'react';
import BaseModal from '../modals/BaseModal';

/**
 * DeleteConfirmModal — wraps BaseModal with the standard chat message
 * deletion confirmation UI (cancel + red delete button).
 *
 * Used for both single-message and bulk-delete confirmations.
 */
const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, type = 'single', count = 0 }) => {
  const title = type === 'single' ? 'Delete Message?' : `Delete ${count} Messages?`;

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      subtitle="Are you sure you want to delete? This action cannot be undone."
      icon={
        <svg className="w-8 h-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
        </svg>
      }
      iconBgColor="#FEF2F2"
    >
      <div className="flex gap-3 mt-2">
        <button
          onClick={onClose}
          className="flex-1 py-2.5 border border-gray-300 text-gray-700 font-medium rounded-xl hover:bg-gray-50 active:scale-95 transition-all text-sm"
        >
          Cancel
        </button>
        <button
          onClick={onConfirm}
          className="flex-1 py-2.5 bg-red-600 hover:bg-red-700 text-white font-medium rounded-xl active:scale-95 transition-all text-sm shadow-md shadow-red-200"
        >
          Delete
        </button>
      </div>
    </BaseModal>
  );
};

export default DeleteConfirmModal;
